export default "__VITE_ASSET__JbZlkkTp__"